import { render } from "./SignUpDialog.vue?vue&type=template&id=ca1d6d3e&scoped=true&ts=true"
import script from "./SignUpDialog.vue?vue&type=script&lang=ts"
export * from "./SignUpDialog.vue?vue&type=script&lang=ts"

import "./SignUpDialog.vue?vue&type=style&index=0&id=ca1d6d3e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1d6d3e"]])

export default __exports__